<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'Physics',
  render: (h) => h(),
  created() {
    const meshs = this.$parent.$meshs
    const camera = this.$parent.$camera
    const scene = this.$parent.$scene

    scene.collisionsEnabled = true
    scene.enablePhysics(new BABYLON.Vector3(0, -.05, 0), new BABYLON.OimoJSPlugin())

    camera.checkCollisions = true
    camera.applyGravity = true
    camera.ellipsoid = new BABYLON.Vector3(1, 14, 1)

    _.each(meshs, m => {
      if(m.name.substring(0, 2) == 'c_' && m.material) {
        m.isVisible = false
        m.checkCollisions = true
      }
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/world/elements/Physics.vue